import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Network } from '@models/network';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InHomeCollectionService {
  private httpClient = inject(HttpClient);

  /**
   * Retrieves the associated networks for a given In-Home Collection (IHC) provider.
   *
   * @param {number} providerId the ID of the provider whose associated networks are to be fetched
   *
   * @returns {Observable<Network[]>} an Observable that resolves to an array of Network objects
   */
  public getIHCProviderAssociatedNetworks(providerId: number): Observable<Network[]> {
    return this.httpClient.get<Network[]>(
      `${environment.analyteCareApi}/api/v1/in-home/providers/${providerId}/networks`,
    );
  }
}
